var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckIcon = function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.561 4.984a.5.5 0 0 1 .065.704l-7.963 9.59a1.5 1.5 0 0 1-2.308 0l-2.973-3.58a.5.5 0 0 1 .769-.64l2.973 3.58c.2.242.57.242.77 0l7.963-9.589a.5.5 0 0 1 .704-.065",
    clipRule: "evenodd"
  })));
};
export default SvgCheckIcon;